import { lazy } from "common/load/componentUtils";

import { useDrawer } from "client/common/hooks/stackables";

const CartDrawer = lazy(() => import("../components/CartDrawer"));

export type CartDrawerProps = {
  addedCartItemId: number | null;
};

export const useCartDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: CartDrawerProps = { addedCartItemId: null }) => open(CartDrawer, props),
  };
};
